/** API route map: URLS.Controller.BillingCode */
export const BillingCode = {
      Name: 'BillingCode/',
      GetAll: 'get-all-billing-codes',
      Add: 'add-billing-code',
      Delete: 'delete-billing-code',
      Update: 'update-billing-code',
      SearchBillingCode: 'search-billing-code',
      GetBillingCodes: 'get-billing-codes',
};
